module.exports = __webpack_public_path__ + "img/ebay.2ae187f8.gif";